import type { ComponentProps } from 'react';

export type BoxProps = ComponentProps<'div'>;

export const Box = ({ children, ...props }: BoxProps) => <div {...props}>{children}</div>;
